import actions from "@/core/store/modules/captcha/actions";
import getters from "@/core/store/modules/captcha/getters";
import mutations from "@/core/store/modules/captcha/mutations";


export default {
    state: {
        action: null,
        is_active: null,
        type: null,
        googleRecaptchaToken: null,
        api: null,
        captcha_key: null,
        image: null,
        site_key: null,
        limit: null
    },
    getters,
    mutations,
    actions
}